import { render, staticRenderFns } from "./pictogram-statuses-list.vue?vue&type=template&id=b7847162"
import script from "./pictogram-statuses-list.vue?vue&type=script&lang=js"
export * from "./pictogram-statuses-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports